import { render, staticRenderFns } from "./RequestPurpose.vue?vue&type=template&id=e7c25166&scoped=true"
import script from "./RequestPurpose.vue?vue&type=script&lang=js"
export * from "./RequestPurpose.vue?vue&type=script&lang=js"
import style0 from "./RequestPurpose.vue?vue&type=style&index=0&id=e7c25166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c25166",
  null
  
)

export default component.exports